export const countries = [
   "Afghanistan",
   "Albania",
   "Algeria",
   "Alland Islands",
   "American Samoa",
   "Andorra",
   "Angola",
   "Anguilla",
   "Antarctica",
   "Antigua and Barbuda",
   "Argentina",
   "Armenia",
   "Aruba",
   "Australia",
   "Austria",
   "Azerbaijan",
   "Bahamas",
   "Bahrain",
   "Bangladesh",
   "Barbados",
   "Belarus",
   "Belgium",
   "Belize",
   "Benin",
   "Bermuda",
   "Bhutan",
   "Bolivia",
   "Bosnia and Herzegovina",
   "Botswana",
   "Bouvet Island",
   "Brazil",
   "British Indian Ocean Territory",
   "British Virgin Islands",
   "Brunei Darussalam",
   "Bulgaria",
   "Burkina Faso",
   "Burundi",
   "Cambodia",
   "Cameroon",
   "Canada",
   "Cape Verde",
   "Cayman Islands",
   "Central African Republic",
   "Chad",
   "Chile",
   "China",
   "Christmas Island",
   "Cocos (Keeling) Islands",
   "Colombia",
   "Comoros",
   "Congo, Democratic Republic of the",
   "Congo, Republic of the",
   "Cook Islands",
   "Costa Rica",
   "Cote d'Ivoire",
   "Croatia",
   "Cuba",
   "Curacao",
   "Cyprus",
   "Czech Republic",
   "Denmark",
   "Djibouti",
   "Dominica",
   "Dominican Republic",
   "Ecuador",
   "Egypt",
   "El Salvador",
   "Equatorial Guinea",
   "Eritrea",
   "Estonia",
   "Ethiopia",
   "Europe",
   "Falkland Islands (Malvinas)",
   "Faroe Islands",
   "Fiji",
   "Finland",
   "France",
   "French Guiana",
   "French Polynesia",
   "French Southern Territories",
   "Gabon",
   "Gambia",
   "Georgia",
   "Germany",
   "Ghana",
   "Gibraltar",
   "Greece",
   "Greenland",
   "Grenada",
   "Guadeloupe",
   "Guam",
   "Guatemala",
   "Guernsey",
   "Guinea",
   "Guinea-Bissau",
   "Guyana",
   "Haiti",
   "Heard Island and McDonald Islands",
   "Holy See (Vatican City State)",
   "Honduras",
   "Hong Kong",
   "Hungary",
   "Iceland",
   "India",
   "Indonesia",
   "Iran, Islamic Republic of",
   "Iraq",
   "Ireland",
   "Isle of Man",
   "Israel",
   "Italy",
   "Jamaica",
   "Japan",
   "Jersey",
   "Jordan",
   "Kazakhstan",
   "Kenya",
   "Kiribati",
   "Korea, Democratic People's Republic of",
   "Korea, Republic of",
   "Kosovo",
   "Kuwait",
   "Kyrgyzstan",
   "Lao People's Democratic Republic",
   "Latvia",
   "Lebanon",
   "Lesotho",
   "Liberia",
   "Libya",
   "Liechtenstein",
   "Lithuania",
   "Luxembourg",
   "Macao",
   "Macedonia, the Former Yugoslav Republic of",
   "Madagascar",
   "Malawi",
   "Malaysia",
   "Maldives",
   "Mali",
   "Malta",
   "Marshall Islands",
   "Martinique",
   "Mauritania",
   "Mauritius",
   "Mayotte",
   "Mexico",
   "Micronesia, Federated States of",
   "Moldova, Republic of",
   "Monaco",
   "Mongolia",
   "Montenegro",
   "Montserrat",
   "Morocco",
   "Mozambique",
   "Myanmar",
   "Namibia",
   "Nauru",
   "Nepal",
   "Netherlands",
   "New Caledonia",
   "New Zealand",
   "Nicaragua",
   "Niger",
   "Nigeria",
   "Niue",
   "Norfolk Island",
   "Northern Mariana Islands",
   "Norway",
   "Oman",
   "Pakistan",
   "Palau",
   "Palestine, State of",
   "Panama",
   "Papua New Guinea",
   "Paraguay",
   "Peru",
   "Philippines",
   "Pitcairn",
   "Poland",
   "Portugal",
   "Puerto Rico",
   "Qatar",
   "Reunion",
   "Romania",
   "Russian Federation",
   "Rwanda",
   "Saint Barthelemy",
   "Saint Helena",
   "Saint Kitts and Nevis",
   "Saint Lucia",
   "Saint Martin (French part)",
   "Saint Pierre and Miquelon",
   "Saint Vincent and the Grenadines",
   "Samoa",
   "San Marino",
   "Sao Tome and Principe",
   "Saudi Arabia",
   "Senegal",
   "Serbia",
   "Seychelles",
   "Sierra Leone",
   "Singapore",
   "Sint Maarten (Dutch part)",
   "Slovakia",
   "Slovenia",
   "Solomon Islands",
   "Somalia",
   "South Africa",
   "South Korea",
   "South Georgia and the South Sandwich Islands",
   "South Sudan",
   "South Korea",
   "Spain",
   "Sri Lanka",
   "Sudan",
   "Suriname",
   "Svalbard and Jan Mayen",
   "Swaziland",
   "Sweden",
   "Switzerland",
   "Syrian Arab Republic",
   "Taiwan",
   "Tajikistan",
   "Thailand",
   "Timor-Leste",
   "Togo",
   "Tokelau",
   "Tonga",
   "Trinidad and Tobago",
   "Tunisia",
   "Turkey",
   "Turkmenistan",
   "Turks and Caicos Islands",
   "Tuvalu",
   "Uganda",
   "Ukraine",
   "United Arab Emirates",
   "United Kingdom",
   "United Republic of Tanzania",
   "United States",
   "Uruguay",
   "US Virgin Islands",
   "Uzbekistan",
   "Vanuatu",
   "Venezuela",
   "Vietnam",
   "Wallis and Futuna",
   "Western Sahara",
   "Yemen",
   "Zambia",
   "Zimbabwe"
];